import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "レイヤー_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 20 20",
  style: {"enable-background":"new 0 0 20 20"},
  "xml:space": "preserve"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]

type Props = {
  backgroundColor?: string
  color?: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    backgroundColor: null,
    color: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      id: "楕円形_105",
      fill: __props.backgroundColor,
      class: "st0",
      cx: "10",
      cy: "10",
      r: "10"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      id: "線_828",
      fill: __props.color,
      class: "st1",
      d: "M11,12.8H9v-10h2V12.8z"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      id: "線_829",
      fill: __props.color,
      class: "st1",
      d: "M11,17.2H9V15h2V17.2z"
    }, null, 8, _hoisted_4)
  ]))
}
}

})